<template>
  <div class="big active-doctor">
    <div class="container" style="padding: 10px 20px 20px 20px">
      <div class="search-box">
        <!-- 结算账期 -->
        <div class="item">
          <span style="margin-left: 10px">结算账期</span>

          <el-date-picker
            v-model="recommenderLeaderForm.month"
            type="month"
            format="yyyy-MM"
            value-format="yyyy-MM"
            placeholder="请选择"
            size="small"
            :picker-options="pickerOptions"
            clearable
          >
          </el-date-picker>
        </div>

        <!-- 账号 -->
        <div class="item">
          <span style="margin-left: 10px">账号</span>
          <el-input
            v-model="recommenderLeaderForm.phone"
            clearable
            size="small"
            style="width: 180px"
            placeholder="请输入"
          ></el-input>
        </div>

        <!-- 姓名 -->
        <div class="item">
          <span style="margin-left: 10px">姓名</span>
          <el-input
            v-model="recommenderLeaderForm.recommender_name"
            clearable
            size="small"
            style="width: 180px"
            placeholder="请输入"
          ></el-input>
        </div>

        <!-- 工号 -->
        <div class="item">
          <span style="margin-left: 10px">工号</span>
          <el-input
            v-model="recommenderLeaderForm.recommender_code"
            clearable
            size="small"
            style="width: 180px"
            placeholder="请输入"
          ></el-input>

          <el-button
            type="primary"
            size="small"
            style="margin-left: 20px"
            @click="seachEnterFun"
            >查询</el-button
          >

          <el-button type="primary" size="small" @click="resetBtn"
            >重置</el-button
          >

          <el-button
            type="primary"
            size="small"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('1938') : false
            "
            @click="exportBtn"
            >导出</el-button
          >
        </div>
      </div>

      <div style="color: #f56c6c; text-align: left; margin-bottom: 10px">
        注：由于订单数据按支付时间计算，建议每月7号之后导出结算数据
      </div>

      <div class="statistics-card">
        <!-- 获得开单新医生奖励业务人数 -->
        <el-card class="box-card">
          <div class="desc">
            <div class="value">
              {{ recommenderLeaderInfo.recommender_num }}人
            </div>
            <div class="title">获得开单新医生奖励业务人数</div>
          </div>
        </el-card>
        <!-- 区域经理奖励总计 -->
        <el-card class="box-card">
          <div class="desc">
            <div class="value">
              {{ recommenderLeaderInfo.district_manager }}元
            </div>
            <div class="title">区域经理奖励总计</div>
          </div>
        </el-card>
        <!-- 大区副总奖励总计 -->
        <el-card class="box-card">
          <div class="desc">
            <div class="value">
              {{ recommenderLeaderInfo.area_deputy_manager }}元
            </div>
            <div class="title">大区副总奖励总计</div>
          </div>
        </el-card>
        <!-- 区域总经理奖励总计 -->
        <el-card class="box-card">
          <div class="desc">
            <div class="value">{{ recommenderLeaderInfo.area_manager }}元</div>
            <div class="title">区域总经理奖励总计</div>
          </div>
        </el-card>
      </div>

      <div style="border: solid 1px #c9cbd6">
        <el-table
          v-loading="tableLoading"
          :data="recommenderLeaderData"
          tooltip-effect="dark"
          ref="multipleTable"
          style="width: 100%; min-width: 1000px"
          :header-cell-style="{ background: '#F5F5F5' }"
        >
          <el-table-column
            prop="recommender_info"
            label="员工信息"
            width="120"
            fixed="left"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.recommender_name }}</div>
              <div>{{ scope.row.recommender_code }}</div>
              <div>{{ scope.row.phone }}</div>
            </template>
          </el-table-column>

          <el-table-column
            prop="area_name"
            label="大区"
            width="180"
            fixed="left"
          >
          </el-table-column>

          <el-table-column align="center">
            <template slot="header">
              <span style="color: #000">区域经理奖励</span>
            </template>
            <el-table-column
              prop="district_recommender_num"
              label="开单新医生奖励业务人数"
              width="140"
              :fixed="false"
            >
            </el-table-column>
            <el-table-column
              prop="district_recommender_info"
              label="开单新医生奖励业务信息"
              width="160"
              :fixed="false"
            >
            </el-table-column>
            <el-table-column
              prop="district_price"
              label="奖励金额"
              width="140"
              :fixed="false"
            >
            </el-table-column>
          </el-table-column>

          <el-table-column align="center">
            <template slot="header">
              <span style="color: #000">大区副总奖励</span>
            </template>
            <el-table-column
              prop="deputy_recommender_num"
              label="开单新医生奖励业务人数"
              width="140"
              :fixed="false"
            >
            </el-table-column>
            <el-table-column
              prop="deputy_recommender_info"
              label="开单新医生奖励业务信息"
              width="160"
              :fixed="false"
            >
            </el-table-column>
            <el-table-column
              prop="deputy_price"
              label="奖励金额"
              width="140"
              :fixed="false"
            >
            </el-table-column>
          </el-table-column>

          <el-table-column align="center">
            <template slot="header">
              <span style="color: #000">大区总经理奖励</span>
            </template>
            <el-table-column
              prop="area_recommender_num"
              label="开单新医生奖励业务人数"
              width="140"
              :fixed="false"
            >
            </el-table-column>
            <el-table-column
              prop="area_recommender_info"
              label="开单新医生奖励业务信息"
              width="160"
              :fixed="false"
            >
            </el-table-column>
            <el-table-column
              prop="area_price"
              label="奖励金额"
              width="140"
              :fixed="false"
            >
            </el-table-column>
          </el-table-column>

          <el-table-column
            prop="total_price"
            label="奖励金额"
            width="140"
            fixed="right"
          >
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <pagination
        v-show="totalNum > 0"
        :total="totalNum"
        :page.sync="pagination.page"
        :limit.sync="pagination.pageNumber"
        @pagination="getList"
      />
    </div>
  </div>
</template>
  
  <script>
import _ from "lodash";
import dayjs from "dayjs";
import staff from "@/api/staff.js";
import Pagination from "@/components/Pagination/index";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      pickerOptions: {
        disabledDate: this.disabledDate,
      },
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      recommenderLeaderInfo: {},
      recommenderLeaderForm: {
        month: "",
        phone: "",
        recommender_name: "",
        recommender_code: "",
      },

      recommenderLeaderData: [],
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm");
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.initDate();
    this.getList();
  },
  methods: {
    initDate() {
      const date = new Date();
      date.setMonth(date.getMonth() - 1); // 将当前日期减去一个月
      // 设置日期为当月的第一天
      date.setDate(1);
      this.recommenderLeaderForm.month = dayjs(date).format("YYYY-MM");
    },
    disabledDate(date) {
      const today = new Date();
      const currentYear = today.getFullYear();
      const currentMonth = today.getMonth(); // 获取当前月份，0表示1月，11表示12月

      // 禁用当前月份之后的日期（不禁用当前月份）
      return (
        date.getFullYear() > currentYear ||
        (date.getFullYear() === currentYear && date.getMonth() > currentMonth)
      );
    },
    getList() {
      let params = Object.assign(
        {},
        this.pagination,
        this.recommenderLeaderForm
      );
      this.tableLoading = true;
      staff.recommenderleaderreward(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.recommenderLeaderData = data.list;
          this.recommenderLeaderInfo = data.count_data;
          this.totalNum = data.total;
          this.tableLoading = false;
        }
      });
    },
    seachEnterFun() {
      this.pagination.page = 1;
      this.getList();
    },
    resetBtn() {
      this.recommenderLeaderForm = {
        month: "",
        phone: "",
        recommender_name: "",
        recommender_code: "",
      };
      this.getList();
    },
    // 导出
    exportBtn() {
      let params = Object.assign(
        {},
        this.pagination,
        this.recommenderLeaderForm
      );
      const loading = this.$loading();
      staff
        .recommenderleaderrewardexport(params)
        .then((res) => {
          let { code, data } = res;
          if (code == 0) {
            let host = `${document.location.protocol}//${window.location.host}${data.url}`;
            window.open(host);
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
  },
};
</script>
  
  <style lang="scss">
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.active-doctor {
  .search-box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      span {
        display: inline-block;
        margin-right: 4px;
        text-align: right;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }
    .item-content {
      // width: 100%;
      .el-date-editor {
        width: 100%;
      }
    }
  }
  .prompt {
    font-size: 12px;
    text-align: left;
    color: red;
    padding-left: 10px;
    margin-bottom: 10px;
  }
  .statistics-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    margin-right: 18px;
    .box-card {
      width: 19%;
      height: 120px;
      .el-card__body {
        .desc {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .value {
            font-size: 20px;
            font-weight: bold;
            height: 50%;
          }
          .title {
            padding: 10px 0;
            height: 50%;
          }
        }
      }
    }
  }
}
.active-doctor-mess {
  width: 400px !important;
  .el-message-box__message {
    p {
      word-wrap: break-word;
    }
  }
}
.cus-passwordDia {
  .passwordDia-box {
    display: flex;
    align-items: center;
    .label {
      width: 100px;
    }
    .btn {
      margin-left: 10px;
    }
  }
}
</style>
  
  <style lang="scss">
.recommenderLeaderData-sendCardVisible {
  .content-box {
    padding: 20px 10px 0;
    .el-form-item__content {
      display: flex;
      align-items: center;
      .el-input-number {
        width: 100%;
      }
    }
  }
}
</style>
  